export default "__VITE_ASSET__6705c9ea__"